import { CompanyProfileRequest } from '../types/company-profile';

export class GetCompanyDetail {
  static readonly type = '[CompanyDetail] GetCompanyDetail';
}

export class UpdateCompanyDetail {
  static readonly type = '[CompanyDetail] UpdateCompanyDetail';
  constructor(public payload: CompanyProfileRequest) {}
}
